import React, { PropsWithChildren, useEffect } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { BsCardText } from '@react-icons/all-files/bs/BsCardText';
import { useContextSelector } from 'use-context-selector';

import { EditorPlaceholder } from '../../../components';
import { EditorContext } from '../../../contexts';
import { useEditorNode } from '../../../hooks';
import { DocumentPath } from '../../../types';

export interface AccordionContentProps {
  path: DocumentPath;
  expanded: boolean;
  expand: () => void;
  peekable?: boolean;
}

export function AccordionContent({
  children,
  path,
  expanded,
  expand,
  peekable,
}: PropsWithChildren<AccordionContentProps>) {
  useEditorInitializer({ path, onChildSelected: expand });

  return (
    <Panel expanded={expanded} peekable={peekable}>
      { children || (
        <EditorPlaceholder
          icon={<BsCardText />}
          message="아이템을 추가해주세요."
        />
      ) }
    </Panel>
  );
}

function useEditorInitializer({
  path,
  onChildSelected,
}: {
  path: DocumentPath,
  onChildSelected: () => void,
}) {
  const isInEditor = !!useContextSelector(EditorContext, (context) => context);
  const { isChildSelected } = useEditorNode(path);

  useEffect(() => {
    if (!isInEditor) { return; }
    if (!isChildSelected) { return; }
    onChildSelected();
  }, [isChildSelected]);
}

const Panel = styled.div<{ expanded: boolean, peekable?: boolean }>`
  ${({ expanded, peekable }) => css`
    height: ${expanded ? 'auto' : peekable ? '20px' : '0px'};
    overflow: ${expanded ? 'initial' : 'auto hidden'};
  `}
`;

// TODO: decorateComponent에서 overflow가 visible이 아니면 자식의 사이즈는 그만 찾기
